const initialState = {
    message: null,
    isError: true,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SHOW_NOTIFICATION': {
            const { message, isError } = action.payload;
            return {
                ...state,
                message,
                isError,
            };
        }
        case 'CLEAR_NOTIFICATION': {
            return {
                ...state,
                message: null,
            };
        }
        default:
            return state;
    }
};

export default reducer;
